
import { mapGetters, mapState, mapActions } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import TransportadorData, {
  TransportadorDataRequired,
} from "../TransportadorData";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import _ from "lodash";
import { mask } from "vue-the-mask";
import { Money } from "v-money";
import { MONEY as settingMoney, quantityOptions } from "@/modules/Application";
import { store } from "../../storeNfe";

export default {
  name: "app-nfe-form-transportadorTab",
  components: {
    VueSelect,
    Money,
  },
  directives: {
    mask,
  },
  data() {
    return {
      store,
      transportadoras: [],
      quantityOptions,
      selectedTransportador: null,
      transportadorSelected: null,
      selectedVehicle: null,
      keyToRender: 0,
      configMask: settingMoney,
      veiculos: [],
      cliente: null,
      ieOptions: ["Contribuinte", "Isento", "Não contribuinte"],
      fretes: [
        {
          codigo: 0,
          descricao: "Contratação do Frete por conta do Remetente (CIF)",
        },
        {
          codigo: 1,
          descricao: "Contratação do Frete por conta do Destinatário (FOB)",
        },
        {
          codigo: 2,
          descricao: "Contratação do Frete por conta de Terceiros",
        },
        {
          codigo: 3,
          descricao: "Transporte Próprio por conta do Rementente",
        },
        {
          codigo: 4,
          descricao: "Transporte Próprio por conta do Destinatário",
        },
        {
          codigo: 9,
          descricao: "Sem Ocorrência de Transporte",
        },
      ],
      fretesSearched: [],
      enderecos: [],
      fones: null,
      isCnpj: false,
      nomeTransportador: null,
      cpfCnpjTransportador: null,
    };
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  validations: {
    form: TransportadorDataRequired,
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {
      this.fretesSearched = this.fretes;
      if (Object.keys(this.$route.params).length !== 0 && !this.$route.params.fromRetornoCompra) {
        const { deliveryInfo, volume, freightType } =
          this.$route.params.nfeData;
        this.store.formTransportador = deliveryInfo
          ? deliveryInfo?.delivery
          : new TransportadorData({});
        this.selectedTransportador = _.cloneDeep(this.store.formTransportador);
        if (freightType) this.store.formTransportador.frete = freightType;
        if (volume) {
          this.store.formTransportador.quantidade = volume.quantity;
          this.store.formTransportador.especie = volume.species;
          this.store.formTransportador.marca = volume.brand;
          this.store.formTransportador.pesoLiquido = volume.netWeight;
          this.store.formTransportador.pesoBruto = volume.grossWeight;
          this.store.formTransportador.numeracao = volume.numeration;
        }
      } else {
        this.store.formTransportador = new TransportadorData({});
      }
    },
    validateTransportadoraState() {
      // const { $dirty, $error } = this.$v.form[name];
      // return $dirty ? !$error : null;
    },
    onSearchTransportadoras(search, loading) {
      if (search.length) {
        loading(true);
        this.searchTransportadoras(loading, search, this);
      }
    },
    onSearchVeiculo() {},
    searchTransportadoras: _.debounce(async (loading, search, vm) => {
      vm.transportadoras = await vm.getTransportadoras(search);
      loading(false);
    }, 350),
    async saveTransportador() {
      this.addLoadingToButton("saveTransportador");

      if (!this.nomeTransportador) {
        this.$toast.warning("Informe a razão social do transportador");
        this.removeLoadingToButton("saveTransportador");
        return;
      }

      try {
        const newObjetoData = {
          nome: this.nomeTransportador,
          cnpj_cpf: this.cpfCnpjTransportador ?? null,
          pessoa_tipo: [
            {
              id_tipo: 3,
              descricao: "Transportador",
            },
          ],
          veiculos: [],
        };

        const response = await this.$http.post("/pessoa/create", newObjetoData);
        if (response.data) {
          const transportador = {
            ...newObjetoData,
            ...response.data,
            veiculos: response.data.veiculos ?? [],
          };

          this.transportadoras = [transportador, ...this.transportadoras];
          this.selectedTransportador = transportador;
        }

        this.resetNovoTransportadorForm();
        this.$bvModal.hide("newTransportadorNfe");
      } catch {
        this.$toast.error("Erro ao cadastrar transportador");
      }

      this.removeLoadingToButton("saveTransportador");
    },
    resetNovoTransportadorForm() {
      this.nomeTransportador = null;
      this.cpfCnpjTransportador = null;
    },
    onSearchFrete(search, loading) {
      if (search.length) {
        loading(true);
        this.fretesSearched = this.fretes.filter(
          (frete) => frete.codigo == search
        );
        loading(false);
      }
    },
  },
  created() {
    this.getDataInit();
  },
  watch: {
    "store.transportadorImported": {
      handler(transportador) {
        this.selectedTransportador = transportador.deliveryInfo?.delivery;
        this.selectedVehicle = transportador.deliveryInfo?.veiculo;
        if (transportador.freightType)
          this.store.formTransportador.frete = transportador.freightType;
        if (transportador.volume) {
          this.store.formTransportador.quantidade =
            transportador.volume.quantity;
          this.store.formTransportador.especie = transportador.volume.species;
          this.store.formTransportador.marca = transportador.volume.brand;
          this.store.formTransportador.pesoLiquido =
            transportador.volume.netWeight;
          this.store.formTransportador.pesoBruto =
            transportador.volume.grossWeight;
          this.store.formTransportador.numeracao =
            transportador.volume.numeration;
        }
      },
      deep: true,
    },
    selectedTransportador: {
      handler(value) {
        const prevsValues = {
          frete: this.store.formTransportador.frete,
          quantidade: this.store.formTransportador.quantidade,
          especie: this.store.formTransportador.especie,
          marca: this.store.formTransportador.marca,
          pesoLiquido: this.store.formTransportador.pesoLiquido,
          pesoBruto: this.store.formTransportador.pesoBruto,
          numeracao: this.store.formTransportador.numeracao,
          veiculo: this.store.formTransportador?.veiculo ?? null,
        };
        this.store.formTransportador = {
          ...prevsValues,
          ...value,
        };
        if (!value) {
          this.veiculos = [];
          this.selectedVehicle = null;
          this.store.formTransportador = {
            ...prevsValues,
            ...value,
            veiculos: this.veiculos,
            veiculo: null,
          };
          return;
        }
        this.veiculos = value.veiculos ?? [];
        this.selectedVehicle = value?.veiculo ?? this.veiculos[0] ?? null;
        this.store.formTransportador = {
          ...prevsValues,
          ...value,
          veiculo: this.selectedVehicle,
        };
        this.keyToRender = this.keyToRender + 1;
      },
      deep: true,
      immediate: true,
    },
    "store.currentTab"(newValue, oldValue) {
      if (newValue !== oldValue && newValue === 6 && oldValue < newValue) {
        this.store.formTransportador = {
          ...this.store.formTransportador,
          veiculo: this.selectedVehicle,
        };
      }
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    transportadorName() {
      return !store.formTransportador?.nome ? null : store.formTransportador;
    },
    isTheCurrentTab() {
      return store.currentTab === 5;
    },
  },
};
